import { statusFacilitator } from './models';

export const DEFAULT_LANGUAGE = 'es';
export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX =
  /(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d ]{8,}$)|(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,}$)/;
export const UPPERCASE_REGEX = /[A-Z]/;
export const LOWERCASE_REGEX = /[a-z]/;
export const SPECIAL_CHARACTERS_REGEX =
  /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
export const PHONE_REGEX = '^[0-9]{10}';
export const PHONE_MASK_MEXICO = '00 0000 0000';
export const PHONE_MASK = '00 00 00 00';
export const HOURS_MASK = '00:00';
export const DATE_MASK = 'DD/MM/YYYY';
export const FRONT_URL = 'https://alternadevelop.com/api/v1/';
export const LOCAL_URL = 'http://localhost:3000/api/v1/';
export const PASS_MIN_LENGTH = 8;
export const VALID_EXTENSION_FILES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/jpg',
  'video/mp4',
];

export const TEXT_SEARCH_PLACEHOLDER = [
  'USERS.search-placeholder',
  'FACILITATOR.facilitator-search',
  'COMPANY.company-search',
];

export const createYears = (): Array<{ value: number; id: number }> => {
  const years = [{ id: 2023, value: 2023 }];
  const date = new Date();
  const year = date.getFullYear();

  for (let i = year; i <= year + 7; i++) {
    years.push({ value: i, id: i });
  }

  return years;
};

export const TEXT_TOOLTIP = ['OPORTUNITIES.form-achive'];
export const PATH_LOADER = '/assets/animation/Loader_Admin.json';

export const VALIDATION_RULES = [
  {
    rule: 'AUTH.rule1',
    value: false,
  },
  {
    rule: 'AUTH.rule2',
    value: false,
  },
  {
    rule: 'AUTH.rule3',
    value: false,
  },
  {
    rule: 'AUTH.rule4',
    value: false,
  },
];

export const ICONS_AND_PATH = [
  {
    name: 'gold-badge',
    path: 'assets/icons/gold_badge.svg',
  },
  {
    name: 'carnation',
    path: 'assets/icons/carnation.svg',
  },
  {
    name: 'bellflower',
    path: 'assets/icons/bellflower.svg',
  },
  {
    name: 'sunflower',
    path: 'assets/icons/sunflower.svg',
  },
  {
    name: 'tulip',
    path: 'assets/icons/tulip.svg',
  },
  {
    name: 'seed',
    path: 'assets/icons/seed.svg',
  },
  {
    name: 'faceSmile',
    path: 'assets/icons/face_smile.svg',
  },
  {
    name: 'faceSad',
    path: 'assets/icons/face_sad.svg',
  },
  {
    name: 'faceLove',
    path: 'assets/icons/face_love.svg',
  },
  {
    name: 'mainBanner',
    path: 'assets/icons/banerAlterna.svg',
  },
  {
    name: 'hidePassword',
    path: 'assets/icons/Eye.svg',
  },
  {
    name: 'passwordOpen',
    path: 'assets/icons/openEye.svg',
  },
  {
    name: 'hidePasswordUntouched',
    path: 'assets/icons/grayEye.svg',
  },
  {
    name: 'doneCheck',
    path: 'assets/icons/DoneCheck.svg',
  },
  {
    name: 'arrow',
    path: 'assets/icons/arrow.svg',
  },
  {
    name: 'undoneCheck',
    path: 'assets/icons/List Check.svg',
  },
  {
    name: 'banner',
    path: 'assets/icons/Logo.svg',
  },
  {
    name: 'bars',
    path: 'assets/icons/Menu.svg',
  },
  {
    name: 'dashboard',
    path: 'assets/icons/Dashboard.svg',
  },
  {
    name: 'users',
    path: 'assets/icons/Users.svg',
  },
  {
    name: 'Oportunities',
    path: 'assets/icons/Oportunidades.svg',
  },
  {
    name: 'notifications',
    path: 'assets/icons/Notificaciones.svg',
  },
  {
    name: 'free-companies',
    path: 'assets/icons/free-companies.svg',
  },
  {
    name: 'reports',
    path: 'assets/icons/reports.svg',
  },
  {
    name: 'challenges',
    path: 'assets/icons/challenge.svg',
  },
  {
    name: 'challengesActive',
    path: 'assets/icons/challengeActive.svg',
  },
  {
    name: 'star',
    path: 'assets/icons/Stars.svg',
  },
  {
    name: 'dashColor',
    path: 'assets/icons/dashColor.svg',
  },
  {
    name: 'usersColor',
    path: 'assets/icons/usersColor.svg',
  },
  {
    name: 'playColor',
    path: 'assets/icons/Oportunidadescolor.svg',
  },
  {
    name: 'altavozColor',
    path: 'assets/icons/altavozColor.svg',
  },
  {
    name: 'flagColor',
    path: 'assets/icons/flagColor.svg',
  },
  {
    name: 'crossMenu',
    path: 'assets/icons/cross.svg',
  },
  {
    name: 'cat-Banner',
    path: 'assets/icons/CatUser.svg',
  },
  {
    name: 'mxn-flag',
    path: 'assets/icons/Bandera=Mexico.svg',
  },
  {
    name: 'gua-flag',
    path: 'assets/icons/Bandera=Guatemala.svg',
  },
  {
    name: 'salv-flag',
    path: 'assets/icons/Bandera=Salvador.svg',
  },
  {
    name: 'hon-flag',
    path: 'assets/icons/Bandera=Honduras.svg',
  },
  {
    name: 'profilePhoto',
    path: 'assets/icons/defaultPhoto.svg',
  },
  {
    name: 'whatsApp',
    path: 'assets/icons/whasap.svg',
  },
  {
    name: 'mailLetter',
    path: 'assets/icons/mailer.svg',
  },
  {
    name: 'file',
    path: 'assets/icons/file.svg',
  },
  {
    name: 'fileCross',
    path: 'assets/icons/filecoss.svg',
  },
  {
    name: 'tableIcon',
    path: 'assets/icons/tableIcon.svg',
  },
  {
    name: 'houseIcon',
    path: 'assets/icons/house.svg',
  },
  {
    name: 'genreIcon',
    path: 'assets/icons/genreicon.svg',
  },
  {
    name: 'medallIcon',
    path: 'assets/icons/medallStar.svg',
  },
  {
    name: 'line',
    path: 'assets/icons/Line.svg',
  },
  {
    name: 'bussinesProfileDefault',
    path: 'assets/icons/bussinesDefault.svg',
  },
  {
    name: 'emoji',
    path: 'assets/icons/Emoji.svg',
  },
  {
    name: 'heart',
    path: 'assets/icons/kokoro.svg',
  },
  {
    name: 'info',
    path: 'assets/icons/Info.svg',
  },
  {
    name: 'searchIcon',
    path: 'assets/icons/Search.svg',
  },
  {
    name: 'worried',
    path: 'assets/icons/worried.svg',
  },
  {
    name: 'trendUp',
    path: 'assets/icons/Trendup.svg',
  },
  {
    name: 'trendDown',
    path: 'assets/icons/Trenddown.svg',
  },
  {
    name: 'challengeFlower',
    path: 'assets/icons/Flor_Reto.svg',
  },
  {
    name: 'maleIcon',
    path: 'assets/icons/Male.svg',
  },
  {
    name: 'femaleIcon',
    path: 'assets/icons/Female.svg',
  },
  {
    name: 'noBinari',
    path: 'assets/icons/Nonbinary.svg',
  },
  {
    name: 'noStar',
    path: 'assets/icons/emptyStar.svg',
  },
  {
    name: 'noFlower',
    path: 'assets/icons/emptyFlower.svg',
  },
  {
    name: 'lock',
    path: 'assets/icons/Lock.svg',
  },
  {
    name: 'playMedia',
    path: 'assets/icons/Play.svg',
  },
  {
    name: 'playingMedia',
    path: 'assets/icons/isPlaying.svg',
  },
  {
    name: 'iconInfoTooltip',
    path: 'assets/icons/infoIconTooltip.svg',
  },
  {
    name: 'noDataList',
    path: 'assets/icons/noData.svg',
  },
  {
    name: 'staff',
    path: 'assets/icons/Personal.svg',
  },
  {
    name: 'sells',
    path: 'assets/icons/Ventas.svg',
  },
  {
    name: 'improve',
    path: 'assets/icons/improve.svg',
  },
  {
    name: 'correctIcon',
    path: '/assets/icons/correctIcon.svg',
  },
  {
    name: 'equalIcon',
    path: '/assets/icons/equalIcon.svg',
  },
  {
    name: 'wrongIcon',
    path: '/assets/icons/wrongIcon.svg',
  },
];

export const ICON_HEADER = [
  {
    icon: 'dashboard',
    iconActive: 'dashColor',
    title: 'NAV.metrics',
    route: '/home/dashboard',
    svg: true,
    role: ['Admin', 'Facilitator'],
  },
  {
    icon: 'users',
    iconActive: 'usersColor',
    title: 'NAV.facilitators',
    route: '/pages/userdash',
    svg: true,
    role: ['Admin', 'Facilitator'],
  },
  {
    icon: 'challenges',
    iconActive: 'challengesActive',
    title: 'NAV.administration',
    route: '/challenges/challenges',
    svg: true,
    role: ['Admin'],
  },

  // ❌ NO se tendría compañias (dejado comentado)
  // {
  //   icon: 'free-companies',
  //   iconActive: 'free-companies',
  //   title: 'NAV.free-companies',
  //   route: '/free-companies/free-companies',
  //   svg: true,
  //   role: ['Admin'],
  // },

  {
    icon: 'Oportunities',
    iconActive: 'playColor',
    title: 'NAV.oportunities',
    route: '/oport/oportunities',
    svg: true,
    role: ['Admin', 'Facilitator'],
  },
  {
    icon: 'notifications',
    iconActive: 'altavozColor',
    title: 'NAV.Notificaciones',
    route: '/notifications/notifications',
    svg: true,
    role: ['Admin'],
  },

  // ❌ NO se tendría reportes (dejado comentado)
  // {
  //   icon: 'reports',
  //   iconActive: 'reports',
  //   title: 'NAV.reports',
  //   route: '/reports/reports',
  //   svg: true,
  //   role: ['Admin'],
  // },

  // ❌ NO se tendría bitácora (zoho logs) (dejado comentado)
  // {
  //   icon: 'sync',
  //   iconActive: 'sync',
  //   title: 'NAV.zohoLogs',
  //   route: '/reports/logs',
  //   svg: false,
  //   role: ['Admin'],
  // },

  // NUEVOS ROLES (solo 1 opción cada uno)
  {
    icon: 'star',
    iconActive: 'star',
    title: 'NAV.premium',
    route: '/premium',
    svg: true,
    role: ['Premium'],
  },
  {
    icon: 'staff',
    iconActive: 'staff',
    title: 'NAV.standard',
    route: '/standard',
    svg: true,
    role: ['Standard'],
  },
];

/*
export const ROUTES_SIDE_BAR = [
  '/home/dashboard',

  // Espacio Facilitadores (antes Organizaciones)
  '/pages/userdash',

  // Espacio Coordinación Admin (renombramos Retos)
  '/challenges/challenges',

  // ❌ Compañias (comentado)
  // '/free-companies/free-companies',

  '/oport/oportunities',
  '/notifications/notifications',

  // ❌ Reportes (comentado)
  // '/reports/reports',

  // ❌ Bitácora / Logs (comentado)
  // '/reports/logs'
];
*/

export const PROFILES = [
  {
    title: 'DASHBOARD.Allied',
    subt1: 'DASHBOARD.total',
    subt2: 'DASHBOARD.actives',
    total: 0,
    actives: 0,
  },
  {
    title: 'DASHBOARD.facilitators',
    subt1: 'DASHBOARD.total',
    subt2: 'DASHBOARD.actives',
    total: 0,
    actives: 0,
  },
  {
    title: 'DASHBOARD.groups',
    subt1: 'DASHBOARD.total',
    subt2: 'DASHBOARD.actives',
    total: 0,
    actives: 0,
  },
  {
    title: 'DASHBOARD.enterprises',
    subt1: 'DASHBOARD.total',
    subt2: 'DASHBOARD.actives',
    total: 0,
    actives: 0,
  },
];

export const DATA_GENERAL = [
  {
    key: 'economic_sectors',
    title: 'Sectores económicos',
    total: 0,
  },
  {
    key: 'businesswomen',
    title: 'Empresarias mujeres',
    total: 0,
  },
  {
    key: 'operating_business',
    title: 'Empresas operando',
    total: 0,
  },
  {
    key: 'formalized_business',
    title: 'Empresas formalizadas',
    total: 0,
  },
];

export const DUMMY_RANKING = [
  {
    company: 'Alfonso del Ramo Rocio Murcia',
    flag: 'hon-flag',
    country: 'México',
    sells: 30,
    sellstatus: 'up',
    status: 'Finalizado',
    achievements: {
      challenges: 20,
      challenges2: 5,
    },
  },
  {
    company: 'Rocio Muriel',
    flag: 'hon-flag',
    country: 'Guatemala',
    sells: 10,
    sellstatus: 'down',
    status: 'Tribu',
    achievements: {
      challenges: 20,
      challenges2: 5,
    },
  },
  {
    company: 'Rocio Muriel',
    flag: 'hon-flag',
    country: 'Guatemala',
    sells: 20,
    sellstatus: 'up',
    status: 'Finalizado',
    achievements: {
      challenges: 20,
      challenges2: 5,
    },
  },
  {
    company: 'Rocio Muriel',
    flag: 'hon-flag',
    country: 'Guatemala',
    sells: 10,
    sellstatus: 'up',
    status: 'Activo',
    achievements: {
      challenges: 20,
      challenges2: 5,
    },
  },
  {
    company: 'Rocio Muriel',
    flag: 'hon-flag',
    country: 'Guatemala',
    sells: 5,
    sellstatus: 'down',
    status: 'Activo',
    achievements: {
      challenges: 20,
      challenges2: 5,
    },
  },
];

export const FILTER_OPTIONS = ['USERS.year-filter', 'USERS.all-years'];

export const USERS_TABS = [
  {
    title: 'USERS.dash-user',
  },
  {
    title: 'USERS.table-user',
  },
  {
    title: 'USERS.agencies',
  },
  {
    title: 'USERS.all-companies',
  },
];

export const REPORTS_TABS = [
  {
    title: 'REPORTS.general',
  },
  {
    title: 'REPORTS.time-app',
  },
  {
    title: 'REPORTS.base-line',
  },
];

export const TABS_COMPANY = [
  {
    title: 'Métricas clave',
  },
  {
    title: 'Progreso',
  },
  {
    title: 'Retroalimentación',
  },
];

export const ORGANIZATION_TEXT_DONE = 'Organización creada con éxito';

export const ORDER_LIST_FACILITATOR = [
  {
    value: 'names',
    up: 1,
    down: -1,
  },
  {
    email: 'email',
    up: 1,
    down: -1,
  },
  {
    date: 'created_At',
    up: 1,
    down: -1,
  },
];

export const LEVEL_ALLIES = [
  {
    level: 'Bronce',
  },
  {
    level: 'Plata',
  },
  {
    level: 'Oro',
  },
];

export const CATEGORY_OPTIONS_ALLIED = [
  {
    option: 'ONG local',
    option2: 'México',
    flag: 'mxn-flag',
    country_code: '+52',
  },
  {
    option: 'ONG internacional',
    option2: 'Guatemala',
    flag: 'gua-flag',
    country_code: '+502',
  },
  {
    option: 'Microfinanciera',
    option2: 'El Salvador',
    flag: 'salv-flag',
    country_code: '+503',
  },
  {
    option: 'CAMs',
    option2: 'Honduras',
    flag: 'hon-flag',
    country_code: '+504',
  },
];

export const CATEGORY_OPTIONS = [
  'Microfinanciera',
  'ONG local',
  'ONG internacional',
  'CAMs',
  'Cooperación Internacional',
  'Incubadora',
  'Banco',
  'Sector público',
  'Sector Privado',
  'Academia',
];

export const COUNTRIES = {
  México: 0,
  Guatemala: 1,
  elSalvador: 2,
  Honduras: 3,
};

export const ALLY_LVL = {
  Bronce: 0,
  Plata: 1,
  Oro: 2,
};

export const FACILITATOR_TABLE_TITLES = [
  {
    title: 'FACILITATOR.dash-fcilitator',
  },
  {
    title: 'FACILITATOR.tab-usuarios',
  },
  {
    title: 'FACILITATOR.facilitatro-table',
  },
  {
    title: 'FACILITATOR.dash-bussines',
  },
  {
    title: 'FACILITATOR.bussines-tables',
  },
];

export const GROUP_TABLE_FACILITATOR_DETAIL = [
  {
    title: 'Grupo(s) Activos',
  },
  {
    title: 'Grupos(s) Inactivos',
  },
];

export const LIST_COMPANY_COLUMN = [
  'Nombre',
  'Teléfono',
  'Bussines',
  'challenge-on',
  'activity',
  'status',
];

export const LIST_FACILITATOR_COLUMN = [
  'image',
  'Nombre',
  'Correo electronico',
  'Teléfono',
  'Grupo a cargo',
  'agency',
  'Fecha de creación',
  'Estado',
];

export const LIST_GROUPLIST_COLUMN = [
  'allied_name',
  'group_name',
  'facilitator',
  'bussines',
  'start-date',
  'end-date',
  'status',
  'actions',
];

export const LIST_OPORTUNITIES_COLUMN = [
  'image',
  'title',
  'created',
  'type',
  'likes',
  'edit',
  'erase',
];

export const ORGANIZATION_DETAIL_TABLES = [
  {
    title: 'ORGANIZATION.dash-group',
  },
  {
    title: 'ORGANIZATION.list-bussines',
  },
];

export const DUMMY_DATA_COMPANY_VALORATION = {
  title: 'Ventas al mes',
  icon: 'bars',
  amount1: '$5000',
  amount2: '$8000',
};

export const DUMMY_DATA_COMPANY_EMPLOYEES = {
  title: 'Empleados',
  fullTimeStart: '3 TC',
  fullTimeeEnd: '5 TC',
  partialTimeStart: '1M',
  partialTimeEnd: '0 MT',
};

export const COMPANY_CHALLENGE = [
  {
    title: 'Reto 1',
  },
  {
    title: 'Reto 2',
  },
  {
    title: 'Reto 3',
  },
  {
    title: 'Reto 4',
  },
  {
    title: 'Reto 5',
  },
];

export const COMPANY_DEFIANCE = [
  {
    title: 'COMPANY.challenges-done',
    type: [
      {
        type1: 'COMPANY.promos-and-discount',
      },
      {
        type1: 'COMPANY.financial-skills',
      },
    ],
    status: 'DONE',
  },
  {
    title: 'COMPANY.challenges-done',
    type: [],
    status: '',
  },
  {
    title: 'COMPANY.challenges-done',
    type: [],
    status: '',
  },
  {
    title: 'COMPANY.challenges-done',
    type: [],
    status: '',
  },
];

export const LIST_NOTI_HEADER_TABLE = [
  'image',
  'noti-title',
  'programing',
  'target',
  'edit',
  'delete',
];

export const CHIPS_NOTI = [
  {
    title: 'NOTIFICATIONS.all',
    value: 'all',
  },
  {
    title: 'NAV.allies',
    value: 'alides',
  },
  {
    title: 'DASHBOARD.facilitators',
    value: 'companies',
  },
  {
    title: 'DASHBOARD.enterprises',
    value: 'facilitators',
  },
];

export const OBJ_CHIPS = {
  0: 'all',
  1: 'allies',
  2: 'facilitators',
  3: 'companies',
};

export const OBJ_CHIPS_NAMES = {
  all: 0,
  allies: 1,
  facilitators: 2,
  companies: 3,
};

export const TYPE_OPORT = {
  0: 'pdf',
  1: 'picture',
  2: 'video',
  3: 'notice',
};

export const ID_TYPE_OPORT = {
  pdf: 0,
  picture: 1,
  video: 2,
  notice: 3,
};

export const LIST_OPORTUNITIES_SUBJTECT = [
  {
    title: 'Mercado',
  },
  {
    title: 'Finanzas',
  },
  {
    title: 'Talento',
  },
];

export const DUMMY_OPTIONS_FILTER = [
  {
    title: 'Todas',
    value: 'all',
  },
  {
    title: 'PDF',
    value: 'pdf',
  },
  {
    title: 'Imagen',
    value: 'picture',
  },
  {
    title: 'Video',
    value: 'video',
  },
  {
    title: 'Aviso',
    value: 'notice',
  },
];

export const TYPE_FILES = {
  pdf: 0,
  picture: 1,
  video: 2,
  notice: 3,
};

export const DUMMY_DATA_COMPANI_STATUS = [
  {
    name: 'Activo',
  },
  {
    name: 'Pre-registrado',
  },
  {
    name: 'Registrado',
  },
  {
    name: 'Abandono',
  },
  {
    name: 'Finalizado',
  },
  {
    name: 'Tribu',
  },
];

export const DUMMY_TIME_GROUP_APP = [
  {
    amount: 0,
    color: '#FEBB39',
    title: 'Al día',
  },
];

export const DUMMY_CARD_CHALLENGES = [
  {
    title: 'Reto',
    nameChallenge: '¿Gano o pierdo...?',
    amount: 100,
    title2: 'Desafíos',
    timeChallenge: 10,
    stars: 0,
    status: 'done',
    erroraverage: 40,
    amountStars: 1,
    amountFlowers: true,

    data: [
      {
        name: 'Reto1',
        series: [
          {
            name: 'progreso',
            value: 100,
          },
          {
            name: 'total',
            value: 0,
          },
        ],
      },
    ],
  },
  {
    title: 'Reto',
    nameChallenge: '¿Gano o pierdo...?',
    amount: 100,
    title2: 'Desafíos',
    timeChallenge: 10,
    stars: 0,
    status: 'done',
    erroraverage: 20,
    amountStars: 0,
    amountFlowers: false,
    data: [
      {
        name: 'Reto1',
        series: [
          {
            name: 'progreso',
            value: 10,
          },
          {
            name: 'total',
            value: 90,
          },
        ],
      },
    ],
  },
  {
    title: 'Reto',
    nameChallenge: '¿Gano o pierdo...?',
    amount: 100,
    title2: 'Desafíos',
    timeChallenge: 10,
    stars: 0,
    status: 'unlock',
    erroraverage: 20,
    amountStars: 0,
    amountFlowers: false,
    data: [
      {
        name: 'Reto1',
        series: [
          {
            name: 'progreso',
            value: 0,
          },
          {
            name: 'total',
            value: 100,
          },
        ],
      },
    ],
  },
  {
    title: 'Reto',
    nameChallenge: '¿Gano o pierdo...?',
    amount: 100,
    title2: 'Desafíos',
    timeChallenge: 10,
    stars: 0,
    status: 'unlock',
    erroraverage: 20,
    amountStars: 0,
    amountFlowers: false,
    data: [
      {
        name: 'Reto1',
        series: [
          {
            name: 'progreso',
            value: 0,
          },
          {
            name: 'total',
            value: 100,
          },
        ],
      },
    ],
  },
  {
    title: 'Reto',
    nameChallenge: '¿Gano o pierdo...?',
    amount: 100,
    title2: 'Desafíos',
    timeChallenge: 10,
    stars: 0,
    status: 'unlock',
    erroraverage: 20,
    amountStars: 0,
    amountFlowers: false,
    data: [
      {
        name: 'Reto1',
        series: [
          {
            name: 'progreso',
            value: 0,
          },
          {
            name: 'total',
            value: 100,
          },
        ],
      },
    ],
  },
];

export const DUMMY_TIME_DATA_PLATFORM_COMPANIES = [
  {
    amount: 49,
    title: 'Minutos al día en la plataforma',
    color: '#3C7773',
  },
  {
    amount: 30,
    title: 'Minutos por semana en retos',
    color: '#FEBB39',
  },
  {
    amount: 20,
    title: 'Minutos por semana en oportunidades',
    color: '#F7503E',
  },
  {
    amount: 10,
    title: 'Minutos por semana en esfuerzo',
    color: '#414E9C',
  },
];

export const DUMMY_COMMENTS_COMPANIES = [
  {
    icon: 'emoji',
    challenge: 'Reto 1',
    nameChallenge: '¿Gano o pierdo dinero?',
  },
  {
    icon: 'emoji',
    challenge: 'Reto 2',
    nameChallenge: '¿Cómo vender a mis clientes actuales?',
  },
];

//graph

export const DUMMY_STAGES = [
  {
    grouth: 0,
    color: '#43A047',
    name: 'Crecimiento',
    key: 'growth',
  },
  {
    grouth: 0,
    color: '#B28224',
    name: 'Primeras ventas',
    key: 'first_sales',
  },
  {
    grouth: 0,
    color: '#151D49',
    name: 'Punto de equilibrio',
    key: 'break_even_point',
  },
  {
    grouth: 0,
    color: '#981D10',
    name: 'Idea o prototipo',
    key: 'ideas_or_prototype',
  },
];

export const STATUS_COMPANIES = [
  {
    name: 'Activo',
    color: '#3C7773',
  },
  {
    name: 'Pre-registrado',
    color: '#43A047',
  },
  {
    name: 'Registrado',
    color: '#FEBB39',
  },
  {
    name: 'Abandono',
    color: '#F7503E',
  },
  {
    name: 'Finalizado',
    color: '#414E9C',
  },
  {
    name: 'Tribu',
    color: '#525252',
  },
];

export const DUMMY_STATUS_GRAPH = [
  {
    name: 'Activo',
    value: 0,
  },
  {
    name: 'Pre-registrado',
    value: 0,
  },
  {
    name: 'Registrado',
    value: 0,
  },
  {
    name: 'Abandono',
    value: 0,
  },
  {
    name: 'Finalizado',
    value: 0,
  },
  {
    name: 'Tribu',
    value: 0,
  },
];

export const BUSINES_DATA_STAGES = [
  {
    grouth: 0,
    color: '#FEBB39',
    name: 'Crecimiento',
  },
  {
    grouth: 0,
    color: '#FEBB39',
    name: 'Primeras ventas',
  },
  {
    grouth: 0,
    color: '#FEBB39',
    name: 'Punto de equilibrio',
  },
  {
    grouth: 0,
    color: '#FEBB39',
    name: 'Idea o prototipo',
  },
  {
    grouth: 0,
    color: '#FEBB39',
    name: 'Idea o prototipo',
  },
  {
    grouth: 0,
    color: '#FEBB39',
    name: 'Idea o prototipo',
  },
];

//organization

export const STATUS_FACILITATORS_CAKE_LABELS = [
  {
    name: 'Activo',
    color: '#3C7773',
  },
  {
    name: 'Pre-registrado',
    color: '#414E9C',
  },
  {
    name: 'Registrado',
    color: '#FEBB39',
  },
  {
    name: 'Deshabilitado',
    color: '#F7503E',
  },
  {
    name: 'Inactivo',
    color: '#43A047',
  },
];

//DONUT GRAPH OPTIONS

export const DUMMY_DONUT_GRAPH_OPTIONS = {
  radius: 26,
  backgroundPadding: 0,
  outerStrokeWidth: 10,
  innerStrokeWidth: 8,
  showUnits: false,
  showSubtitle: false,
  showTitle: false,
  space: -10,
  outerStrokeColor: 10,
  backgroundStrokeWidth: 8,
  innerStrokeColor: '#F2EDE3',
  animation: true,
  animationDuration: 300,
};

//DASH-ORGANIZATIONS

export const GENERAL_DETAIL_ORGANIZATIONS = [
  {
    name: 'USERS.dsh-actives',
  },
  {
    name: 'USERS.dsh-inactives',
  },
  {
    name: 'USERS.dsh-prox',
  },
  {
    name: 'USERS.dsh-amoun-org',
  },
];

export const CATEGORY_ORGANIZATION_CAKE_LABELS = [
  {
    name: 'Microfinan...',
    color: '#181818',
  },
  {
    name: 'ONG Local',
    color: '#FEBB39',
  },
  {
    name: 'ONG internacional',
    color: '#FEBB39',
  },

  {
    name: 'CAMs',
    color: '#F7503E',
  },

  {
    name: 'Cooperac...',
    color: '#525252',
  },

  {
    name: 'Incubadora',
    color: '#43A047',
  },
  {
    name: 'Banco',
    color: '#B28224',
  },
  {
    name: 'Sec Publico...',
    color: '#B28224',
  },
  {
    name: 'Sec Privado',
    color: '#3C7773',
  },
  {
    name: 'Academia',
    color: '#414E9C',
  },
];

export const DUMMY_ORGANIZATION_BY_COUNTRY = [
  {
    flag: 'mxn-flag',
    color: '#3C7773',
  },
  {
    flag: 'gua-flag',
    color: '#FEBB39',
  },
  {
    flag: 'hon-flag',
    color: '#3C7773',
  },
  {
    flag: 'salv-flag',
    color: '#FEBB39',
  },
];

export const BASE_ORG_SUSCRIPTION = [
  {
    name: 'Bronce',
  },
  {
    name: 'Plata',
  },
  {
    name: 'Oro',
  },
];

export const SUSCRIPTION_ORG_CAKE_LABELS = [
  {
    name: 'Bronce',
    color: '#F7503E',
  },
  {
    name: 'Plata',
    color: '#414E9C',
  },
  {
    name: 'Oro',
    color: '#3C7773',
  },
];

export const DUMMY_LABEL_FACILITATORS_STATUS = [
  //
  {
    name: 'Activo',
    color: '#3C7773',
  },
  {
    name: 'Pre-registrado',
    color: '#43a047',
  },
  {
    name: 'Registrado',
    color: '#FEBB39',
  },
  {
    name: 'Deshabilitado',
    color: '#F7503E',
  },
  {
    name: 'Inactivo',
    color: '#414E9C',
  },
];

export const LABEL_BAR_ACTIVES = [
  {
    name: 'Activos',
    color: '#E8F5E9',
  },
  {
    name: 'Inactivos',
    color: '#43A047',
  },
];

//LIST FACILITATORS

export const FACILITATOR_COLOR_STATUS = {
  [statusFacilitator.active]: {
    text: 'DASHBOARD.actives',
    color: '#3C7773',
  },
  [statusFacilitator.true]: {
    text: 'DASHBOARD.actives',
    color: '#3C7773',
  },
  [statusFacilitator.inactive]: {
    text: 'DASHBOARD.inactives',
    color: '#414E9C',
  },
  [statusFacilitator.preRegistered]: {
    text: 'DASHBOARD.pre-registred',
    color: '#43A047',
  },
  [statusFacilitator.registered]: {
    text: 'DASHBOARD.registered',
    color: '#FEBB39',
  },
  [statusFacilitator.disabled]: {
    text: 'FACILITATOR.leaver',
    color: '#F7503E',
  },
  [statusFacilitator.false]: {
    text: 'FACILITATOR.leaver',
    color: '#F7503E',
  },
};

//DASH-GROUPS

export const DUMMY_TYPE_SELLERS_GRAPH = [
  {
    name: 'Servicios',
  },
  {
    name: 'Productos',
  },
  {
    name: 'Reventa',
  },
  {
    name: 'Múltiples',
  },
];

export const LABELS_TYPE_SELLERS_GRAPH = [
  {
    name: 'Servicios',
    color: '#FEBB39',
  },
  {
    name: 'Productos',
    color: '#3C7773',
  },
  {
    name: 'Reventa',
    color: '#414E9C',
  },
  {
    name: 'Múltiples',
    color: '#F7503E',
  },
];

export const DUMMY_ORGANIZATION_BY_GENDER = [
  {
    amount: 0,
    flag: 'maleIcon',
    color: '#3C7773',
    time: '70 min',
    title: 'Retos',
    name: 'masculine',
  },
  {
    amount: 0,
    flag: 'femaleIcon',
    color: '#3C7773',
    time: '70 min',
    title: 'Oportunidades',
    name: 'femenine',
  },
  {
    amount: 0,
    flag: 'noBinari',
    color: '#FEBB39',
    time: '70 min',
    title: 'Esfuerzo',
    name: 'other',
  },
];

export const DUMMY_TIME_GROUPS_SECCIONS = [
  {
    amount: 5,
    color: '#3C7773',
    time: 0,
    title: 'Retos',
  },
  {
    amount: 5,
    color: '#3C7773',
    time: 0,
    title: 'Oportunidades',
  },
  {
    amount: 5,
    color: '#3C7773',
    time: 0,
    title: 'Esfuerzo',
  },
];

//DASH-COMPANIES

export const COMPANIES_SALES = [
  {
    name: 'Productos',
  },
  {
    name: 'Servicios',
  },
  {
    name: 'Reventa',
  },
  {
    name: 'Múltiples',
  },
];

export const COMPANIES_SALES_LABELS = [
  {
    name: 'Servicios',
    color: '#FEBB39',
  },
  {
    name: 'Productos',
    color: '#3C7773',
  },
  {
    name: 'Reventa',
    color: '#414E9C',
  },
  {
    name: 'Múltiples',
    color: '#F7503E',
  },
];

export const DUMMY_COMPANY_STATUS = [
  {
    name: 'Activo',
  },
  {
    name: 'Abandono',
  },
  {
    name: 'Pre-registrado',
  },
  {
    name: 'Registrado',
  },

  {
    name: 'Finalizado',
  },
  {
    name: 'Tribu',
  },
];

export const DUMMY_COMPANY_STATUS_LABELS = [
  {
    name: 'Pre-registrado',
    color: '#43A047',
  },
  {
    name: 'Registrado',
    color: '#FEBB39',
  },
  {
    name: 'Activo',
    color: '#3C7773',
  },
  {
    name: 'Finalizado',
    color: '#414E9C',
  },
  {
    name: 'Tribu',
    color: '#525252',
  },
  {
    name: 'Abandono',
    color: '#F7503E',
  },
];

//CHALLENGES_COMPANY

export const DUMMY_TIME_ON_PLATFORM = [
  {
    totalTime: 0,
    text: 'Min. al día en la plataforma',
    color: '#3C7773',
  },
  {
    totalTime: 0,
    text: 'Min. por semana en retos',
    color: '#FEBB39',
  },
  {
    totalTime: 0,
    text: 'Min. por semana en perfil',
    color: '#43A047',
  },
  {
    totalTime: 0,
    text: 'Min. por semana en oportunidades',
    color: '#F7503E',
  },
  {
    totalTime: 0,
    text: 'Min. por semana en calculadora',
    color: '#414E9C',
  },
];

export const DUMMY_CHALLENGES_COMPANY = [
  {
    avilable: true,
    challengeTitle: '¿Gano o pierdo...',
    challenge: 'Reto 1',
    progress: {
      current: 80,
      mistakes: 40,
    },
    timeChallenge: {
      total: 40,
      week: 10,
    },
    activitiesDone: [100, 100, 100, 100],
    timeActivities: 10,
    stars: [true, true, true, true],
    flower: 1,
  },
  {
    avilable: true,
    challengeTitle: '¿Cómo vender m...',
    challenge: 'Reto 2',
    progress: {
      current: 10,
      mistakes: 5,
    },
    timeChallenge: {
      total: 5,
      week: 5,
    },
    activitiesDone: [25, 0, 0, 0],
    timeActivities: 10,
    stars: [true, true, false, false],
    flower: 0,
  },
  {
    avilable: false,
    challengeTitle: '¿Quieres crecer?...',
    challenge: 'Reto 3',
    progress: {
      current: 0,
      mistakes: 0,
    },
    timeChallenge: {
      total: 0,
      week: 0,
    },
    activitiesDone: [0, 0, 0, 0],
    timeActivities: 0,
    stars: [false, false, false, false],
    flower: 0,
  },
  {
    avilable: false,
    challengeTitle: '¿Quieres crecer?...',
    challenge: 'Reto 3',
    progress: {
      current: 0,
      mistakes: 0,
    },
    timeChallenge: {
      total: 0,
      week: 0,
    },
    activitiesDone: [0, 0, 0, 0],
    timeActivities: 0,
    stars: [false, false, false, false],
    flower: 0,
  },
  {
    avilable: false,
    challengeTitle: '¿Quieres crecer?...',
    challenge: 'Reto 3',
    progress: {
      current: 0,
      mistakes: 0,
    },
    timeChallenge: {
      total: 0,
      week: 0,
    },
    activitiesDone: [0, 0, 0, 0],
    timeActivities: 0,
    stars: [false, false, false, false],
    flower: 0,
  },
];

export const ICONS_SELECT = {
  correct: 'correctIcon',
  wrong: 'wrongIcon',
  equal: 'equalIcon',
};

export const DUMMY_TITLE_CHALLENGES = [
  'reto 1',
  'reto 2',
  'reto 3',
  'reto 4',
  'reto 5',
];
export const DUMMY_SKILL_GAINED = [
  {
    skillTitle: 'Habilidad 1',
    skillDescription: 'Revisar frecuentemente el precio de ventas',
    initAnswer: {
      value: 'wrong',
      titleAnswer: 'Muy rara vez lo reviso',
    },
    endingAnswer: {
      value: 'correct',
      titleAnswer: 'Si, los reviso periodicamente',
    },
  },
  {
    skillTitle: 'Habilidad 2',
    skillDescription: 'Controlar frecuentemente sus finanzas',
    initAnswer: {
      value: 'equal',
      titleAnswer: 'Aveces anoto mis ventas',
    },
    endingAnswer: {
      value: 'correct',
      titleAnswer: 'Siembre anoto mis ventas',
    },
  },
  {
    skillTitle: 'Habilidad 3',
    skillDescription: 'Analizar sus ventas',
    initAnswer: {
      value: 'wrong',
      titleAnswer: 'Muy rara vez analizo ventas',
    },
    endingAnswer: {
      value: 'equal',
      titleAnswer: 'A veces cuando me acuerdo',
    },
  },
  {
    skillTitle: 'Habilidad 4',
    skillDescription: 'Analizar sus gastos',
    initAnswer: {
      value: 'correct',
      titleAnswer: 'Siempre analizo mis gastos',
    },
    endingAnswer: {
      value: 'correct',
      titleAnswer: 'Siempre analizo mis gastos',
    },
  },
];
``;
//CHALLENGE MODULE

export const DUMMY_LIST_TOP5 = [
  {
    title: '¿Ganas o pierdes...;',
    description: 'Lleva el control financiero',
    amount: 0,
  },
  {
    title: '¿Ganas o pierdes...;',
    description: 'Calcula tu precio de venta',
    amount: 0,
  },
  {
    title: '¿Quieres aumentar...;',
    description: 'Conoce a tus clientes',
    amount: 0,
  },
  {
    title: '¿Quieres seguir cre...;',
    description: 'Busca nuevos clientes',
    amount: 0,
  },
  {
    title: '¿Ganas o pierdes...;',
    description: 'Analiza tus gastos',
    amount: 0,
  },
  {
    title: '¿Ganas o pierdes...;',
    description: 'Analiza tus gastos',
    amount: 0,
  },
];

export const DUMMY_WORST_TOP = [
  {
    title: '¿Quieres seguir cre...;',
    description: 'Haz un discurso de vent...',
    amount: 50,
  },
  {
    title: '¿Quieres seguir cre...;',
    description: 'Aprende a vender online',
    amount: 50,
  },
  {
    title: '¿Quieres seguir cre...;',
    description: 'Haz un discurso de venta...',
    amount: 50,
  },
  {
    title: '¿Quieres seguir cre...;',
    description: 'Organiza tu tienda',
    amount: 50,
  },
  {
    title: '¿Quieres seguir cre...;',
    description: 'Consigue clientes frecuen...',
    amount: 50,
  },
  {
    title: '¿Quieres seguir cre...;',
    description: 'Consigue clientes frecuen...',
    amount: 50,
  },
];

export const DUMMY_CIRCLE_SETTINGS_ITEMS = [
  {
    nameChallenge: '¿Ganas o pierdes...',
    timeSpend: 20,
    color: '#3C7773',
  },
  {
    nameChallenge: '¿Quieres aumentar...',
    timeSpend: 40,
    color: '#414E9C',
  },
  {
    nameChallenge: '¿Quieres seguir...',
    timeSpend: 40,
    color: '#414E9C',
  },
  {
    nameChallenge: 'Salud financiera',
    timeSpend: 20,
    color: '#FEBB39',
  },
  {
    nameChallenge: 'Salud financiera',
    timeSpend: 20,
    color: '#F7503E',
  },
];

export const DUMMY_SATISFIED_LEVELS = [
  {
    title: '¿Gano o pierdo dinero?',
    dontLike: 20,
    good: 30,
    excellent: 50,
  },
  {
    title: 'Calcula tu precio de v...',
    dontLike: 20,
    good: 30,
    excellent: 50,
  },
  {
    title: 'Lleva el control finan...',
    dontLike: 20,
    good: 30,
    excellent: 50,
  },
  {
    title: 'Analiza tus ventas',
    dontLike: 20,
    good: 30,
    excellent: 50,
  },
  {
    title: 'Analiza tus gastos',
    dontLike: 100,
    good: 0,
    excellent: 100,
  },
];

export const DUMMY_ACTIVITIES = [
  {
    title: 'Actividad',
    titleActiviti: 'Promociones y descuentos',
    pre: 40,
    post: 60,
  },
  {
    title: 'Actividad',
    titleActiviti: 'Habilidades financieras',
    pre: 40,
    post: 60,
  },
  {
    title: 'Actividad',
    titleActiviti: 'Intereses y pagos',
    pre: 40,
    post: 60,
  },
  {
    title: 'Actividad',
    titleActiviti: 'Empleados',
    pre: 40,
    post: 60,
  },
];

//masive charge

export const CSV_CHECK = [
  'Registros totales',
  'Registros correctos',
  'Registros con errores',
  'Registros duplicados',
];

export const FACILITATOR_STATUS_FILTER = [
  {
    title: 'Todos',
    value: 'all',
  },
  {
    title: 'Activo',
    value: 'active',
  },
  {
    title: 'Inactivo',
    value: 'inactive',
  },
  {
    title: 'Pre-registrado',
    value: 'pre_registered',
  },
  {
    title: 'registrado',
    value: 'registered',
  },
  {
    title: 'Deshabilitado',
    value: 'disabled',
  },
];
